<template>
  <div class="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-100 flex items-center justify-center p-6">
    <div class="w-full max-w-xl">
      <div class="rounded-2xl shadow-xl bg-white overflow-hidden border border-orange-100">
        <div class="bg-respina-primary px-6 py-6 text-white">
          <div class="flex items-center gap-3">
            <img :src="logoUrl" alt="Respina" class="h-8 w-auto" />
            <div>
              <h1 class="text-xl font-extrabold leading-tight">Access blocked</h1>
              <p class="text-respina-light text-sm opacity-90">This service is not available in your region.</p>
            </div>
          </div>
        </div>

        <div class="p-6">
          <p class="text-gray-700 leading-relaxed">
            Unfortunately, based on your location this service is currently restricted.
          </p>
          <div class="mt-6 flex gap-3 flex-wrap">
            <button
              type="button"
              class="h-11 px-6 bg-respina-primary hover:bg-respina-secondary text-white font-bold rounded-xl transition-all shadow-md hover:shadow-lg"
              @click="retry"
            >
              Retry
            </button>
            <router-link
              to="/auth/login"
              class="h-11 px-6 inline-flex items-center justify-center bg-gray-100 hover:bg-gray-200 text-gray-800 font-bold rounded-xl transition-all"
            >
              Sign in
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logoUrl from "@/assets/respina/logo.png";
import { fetchGeoConfig } from "@/lib/geoConfig";
import { isAuthenticated } from "@/lib/auth";

export default {
  data() {
    return { logoUrl };
  },
  methods: {
    async retry() {
      try {
        await fetchGeoConfig();
        this.$router.replace(isAuthenticated() ? "/airport-board" : "/airport-board");
      } catch {
        // ignore
      }
    },
  },
};
</script>

